import { PageContainer, CashbackTabs, AccountSummary, useHead } from '@mybonus/ui';

import { useExtensionAuthHandover } from './AccountView.hooks';
import { Layout, CashbackListBox, AccountSummaryBox } from './AccountView.parts';

export function AccountView() {
	useHead({ subtitle: 'Mitt konto' });
	useExtensionAuthHandover();

	return (
		<PageContainer>
			<Layout>
				<AccountSummaryBox>
					<AccountSummary />
				</AccountSummaryBox>
				<CashbackListBox>
					<CashbackTabs />
				</CashbackListBox>
			</Layout>
		</PageContainer>
	);
}
